import { useTranslation } from "react-i18next";
import cn from "classnames";
import { Moon, Sun1 } from "iconsax-react";
import { useAccessibilityControls } from "../hooks";
import type { Theme } from "../types";
import GrayscaleIcon from "./GrayscaleIcon";

const THEME_OPTIONS: { value: Theme; renderIcon: (isSelected: boolean) => React.ReactNode }[] = [
  {
    value: "light",
    renderIcon: (isSelected) => <Sun1 size={16} color="currentColor" variant={isSelected ? "Bold" : "Linear"} />,
  },
  {
    value: "dark",
    renderIcon: (isSelected) => <Moon size={16} color="currentColor" variant={isSelected ? "Bold" : "Linear"} />,
  },
  { value: "grayscale", renderIcon: () => <GrayscaleIcon size={16} color="currentColor" /> },
];

export default function ThemeSegmentedControl() {
  const { t } = useTranslation("AccessibilityPanel");
  const { theme, setThemeOption } = useAccessibilityControls();

  return (
    <div className="flex items-center gap-1 surface-secondary-fill radius-sm">
      {THEME_OPTIONS.map((option) => {
        const isSelected = theme === option.value;
        return (
          <button
            key={option.value}
            type="button"
            aria-label={t(option.value)}
            aria-pressed={isSelected}
            onClick={() => setThemeOption(option.value)}
            className={cn(
              "w-8 h-7 flex items-center justify-center radius-sm transition-all cursor-pointer",
              isSelected ? "surface-brand-fill content-static-white" : "content-base-primary hover:surface-base-fill",
            )}>
            {option.renderIcon(isSelected)}
          </button>
        );
      })}
    </div>
  );
}

